import styled from 'styled-components';
import { colorsGreen } from '@src/theme/chakraTheme/colors';

export const BlogImage = styled.img`
  width: 100%;
  margin-bottom: 20px;
`;

export const BlogText = styled.p`
  font-family: ${({ theme }) => theme.fonts.montserrat};
  font-weight: 300;
  color: ${({ theme }) => theme.colors.grey.light};
`;

export const BlogContentTitle = styled.h4`
  font-family: ${({ theme }) => theme.fonts.montserrat};
  color: ${({ theme }) => theme.colors.grey.light};
`;

export const ContentWrapper = styled.div`
  p,
  ol,
  li {
    font-family: ${({ theme }) => theme.fonts.montserrat};
    font-weight: 300;
    color: ${({ theme }) => theme.colors.grey.jumbo};
    font-size: 16px;
    line-height: 32px;
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: ${({ theme }) => theme.fonts.montserrat};
    color: ${({ theme }) => theme.colors.grey.light};
  }

  h3 {
    color: ${({ theme }) => theme.colors.primary};
    font-family: ${({ theme }) => theme.fonts.montserrat};
    font-weight: 700;
    font-size: 24px;
  }

  a {
    color: ${colorsGreen[300]};
    font-family: ${({ theme }) => theme.fonts.montserrat};
    font-weight: 700;
  }
`;
